import { useState, useEffect, ReactNode } from "react";
import CustomRadioButton from "../../components/buttons/CustomRadioButton";
import AddModel from "../../components/Add/AddModel";
import AddBottomButton from "../../components/Add/AddBottomButton";
import { useDispatch } from "react-redux";
import { resetManualState } from "../../store/slices/addManualSlice";
import useApi from "../../services/useApi";
import { useParams, useLocation } from "react-router-dom";
import { inputFieldContent } from "../../components/inputfields/InputFieldContent";
import useTranslation from "../../components/CustomHooks/useTranslation";
import AddInputs from "../../components/Add/AddInputs";
import TextArea from "../../components/inputfields/TextArea";
import CustomModal from "../../components/CustomModal";
import PinVerificationModel from "../../components/Models/PinVerificationModel";
import endpoints from "../../services/endpoints";
import TransactionReceipt from "./TransactionReceipt";
import { fetchAuthSession } from "@aws-amplify/auth";
import Paid from "./Paid";
import PaidMobileMoney from "./PaidMobileMoney";

type Props = {
  children?: ReactNode;
};
export default function AddRaiseETopUpRequest({ children }: Props) {
  const dispatch = useDispatch();
  const location = useLocation();
  const { notEnglish, translate } = useTranslation(inputFieldContent);
  const { id } = useParams();
  const { PostAPI } = useApi();
  const [selectedOption, setSelectedOption] = useState<"Paid" | "Advance">(
    "Paid"
  );
  const { raiseETopUpRequest, raiseETopUpRequestPaid } = endpoints;
  const [verifyLoading, setVerifyLoading] = useState(false);
  const [pin, setPin] = useState<string[]>(new Array(4).fill(""));
  const initialFormData = {
    payment_type: "advance",
    choose_wallet: "E Top Up",
    amount: "",
    request_from: {},
    pin_interval: "",
    isDontAskAgainChecked: false,
    receiver_payment_source: "Bank",
    receiver_bank: {},
    sender_payment_source: "Bank",
    sender_bank: {},
    transaction_receipt: "",
    choose_platform: "",
    hesabpay_account_number: "",
    associated_phone_number: "",
  };
  const [popUpLoading, setPopUpLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  const [responseData, setResponseData] = useState({});
  const [isTransactionReceipt, setIsTransactionReceipt] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isVerificationModelOpen, setIsVerificationModelOpen] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [text, setText] = useState<string>("");
  const [isPopupPage, setIsOpenPage] = useState(1);
  const [textError, setTextError] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const handleInputChange = (key: string, value: string | boolean | any[]) => {
    if (key === "amount" && typeof value === "string") {
      const regex = /^\d*\.?\d{0,2}$/;
      if (!regex.test(value)) return;
    }
    if (key === "associated_phone_number" && typeof value === "string" && value.length > 0) {
      // This regex ensures:
      // 1. "+" symbol only allowed at the beginning
      // 2. No consecutive spaces or hyphens
      // 3. Only numbers, spaces, and hyphens allowed after optional leading "+"
      const regex = /^\+?(?!.*[ -][ -])(?!.*[+].*[+])[0-9 -]*$/;
      if (!regex.test(value)) return;
    }
    if (key === "hesabpay_account_number") {
      value = value.replace(/\s/g, ""); // Remove spaces
    }
    if(key === "payment_type") {
      setText('')
      setFormData(initialFormData)
      setErrors({})
    }
    if(key === "receiver_payment_source" && value === "Cash") {

      setFormData((prevData) => ({
        ...prevData,
        ['sender_payment_source']: value,
      }));
    }
    if(key === "receiver_payment_source") {
      setFormData((prevData) => ({
        ...prevData,
        ['receiver_bank']: {},
        ['sender_bank']: {},
        ['transaction_receipt']: "",
      }));
    }
    if(key === "sender_payment_source") {
      setFormData((prevData) => ({
        ...prevData,
        ['sender_bank']: {},
      }));
    }
    if(key === "receiver_payment_source" && value === "Bank") {
      setFormData((prevData) => ({
        ...prevData,
        ['sender_payment_source']: value,
      }));
    }  
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
    setErrors((prevErrors) => ({
      ...prevErrors,
      [key]: "",
    }));
    if(key === "choose_platform") {
      setFormData((prevData) => ({
        ...prevData,
        hesabpay_account_number: "",
        associated_phone_number: "",
        transaction_receipt: "",
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        hesabpay_account_number: "",
        associated_phone_number: "",
        transaction_receipt: "",
      }));
    }
    if(key === "receiver_payment_source") {
      setFormData((prevData) => ({
        ...prevData,
        receiver_bank: {},
        sender_bank: {},
        transaction_receipt: "",
        choose_platform: "",
        hesabpay_account_number: "",
        associated_phone_number: "",
      }));
      setErrors((prevErrors) => ({
        ...prevErrors,
        receiver_bank: "",
        sender_bank: "",
        transaction_receipt: "",
        choose_platform: "",
        hesabpay_account_number: "",
        associated_phone_number: "",
      }));
    }
  };
  

  useEffect(() => {
    return () => {
      dispatch(resetManualState());
    };
  }, [location.pathname, dispatch]);
  const handleValidation = () => {
    const newErrors: any = {};
    if (formData?.amount === "") {
      newErrors.amount = "This field is required";
    } else if (Number(formData?.amount) < 1) {
      newErrors.amount = "Amount must be at least 1.00 AFA";
    }
    if (Object.keys(formData?.request_from).length === 0) {
      newErrors.request_from = "This field is required";
    }
    if(formData?.payment_type === "paid") {
      if(formData?.receiver_payment_source === "Mobile Money") {
        if(formData?.choose_platform === "") {
          newErrors.choose_platform = "This field is required";
        }
        if(formData?.choose_platform === 'Hesab Pay' && formData?.hesabpay_account_number === "") {
          newErrors.hesabpay_account_number = "This field is required";
        }
        if(formData?.choose_platform !== 'Hesab Pay' ) {
          if(formData?.associated_phone_number === "") {
          newErrors.associated_phone_number = "This field is required";
          } else if(formData.associated_phone_number.length < 10) {
            newErrors.associated_phone_number = "Invalid associated phone number"
          }
        }
        if(formData?.transaction_receipt === "") {
          newErrors.transaction_receipt = "This field is required";
        }
      } else {
        if (Object.keys(formData?.receiver_bank).length === 0) {
          newErrors.receiver_bank = "This field is required";
        }
        if (Object.keys(formData?.sender_bank).length === 0) {
          newErrors.sender_bank = "This field is required";
        }
        if (formData?.transaction_receipt === "") {
          newErrors.transaction_receipt = "This field is required";
        }
      }

    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async () => {
    setLoading(true);
    setPin(new Array(4).fill(""));
    setErrorMessage("");
    setPopUpLoading(false);
    setFormData((prevData) => ({
      ...prevData,
      ['isDontAskAgainChecked']: false,
    }));
    if (!handleValidation()) {
      setLoading(false);
      return;
    } else {
      setIsPopupOpen(true);
      setLoading(false);
      setIsOpenPage(1);
    }
  };
  const handleSubmitPopup = async () => {
    setPopUpLoading(true);
    if (isPopupPage === 1) {
      setIsOpenPage(2);
      setPopUpLoading(false);
      return;
    } else {
      const user = await fetchAuthSession({ forceRefresh: true });
      const timestamp =
        user?.tokens?.idToken?.payload["custom:pin_expiry_timestamp"];
      if (timestamp) {
        const inputDate = new Date(timestamp);
        const currentDate = new Date();
        if (inputDate < currentDate) {
          setIsVerificationModelOpen(true);
          setIsPopupOpen(false);
        } else {
          handleClickVerify(false);
        }
      } else {
        setPopUpLoading(false);
        setIsVerificationModelOpen(true);
        setIsPopupOpen(false);
      }
    }
  };

  const handleFormatValue = (value: Record<string, any>) => {
    if (Object.keys(value).length !== 0) {
      return `${value?.user_code ?? ""} | ${value?.first_name ?? ""} ${
        value?.last_name ?? ""
      }`;
    }
    return "";
  };

  const inputs = {
    "": {
      Amount: {
        required: true,
        disabled: false,
        id: "amount",
        type: "input",
        tabIndex: 0,
        bottom: "mb-0",
      },
      "Request From": {
        id: "request_from",
        type: "dynamic_dropDown",
        required: true,
        disabled: false,
        handelDynamicValue: handleFormatValue,
        tabIndex: 2,
        bottom: "mb-0",
        apiEndPoint: `admins/?type=super_admin&page_number=`,
      },
    },
  };

  const handleClickVerify = async (isPin: boolean) => {
    setVerifyLoading(true);
    setErrorMessage("");
    try {
      if (isPin) {
        if (pin.includes("")) {
          setErrorMessage("This field is required");
          return;
        }
        if (formData.isDontAskAgainChecked && formData.pin_interval === "") {
          setErrors((prevErrors) => ({
            ...prevErrors,
            pin_interval: "This field is required",
          }));
          return;
        }
      }
      let endpoint = raiseETopUpRequest;
      const payload: { [key: string]: any } = {
        payment_type: formData?.payment_type,
        wallet: "etopup",
        amount: Number(formData?.amount),
        request_from: formData?.request_from?.id,
        note: text,
        pin: pin.join(""),
        pin_interval: formData?.pin_interval,
      };
      
      if (formData?.payment_type === "paid") {
        if(formData?.receiver_payment_source === "Mobile Money") {
          payload["sender_source_id"] = formData?.choose_platform === "Hesab Pay" ? formData?.hesabpay_account_number : formData?.associated_phone_number
          payload["e_money_platform"] = formData?.choose_platform;
          payload["sender_payment_source"] = "Mobile Money";
          payload["receiver_payment_source"] = "Mobile Money";
        } else {
          payload["sender_source_id"] = formData?.sender_bank?.id;
          payload["sender_payment_source"] = formData?.sender_payment_source;
          payload["receiver_payment_source"] = formData?.receiver_payment_source;
          payload["receiver_source_id"] = formData?.receiver_bank?.id;
        }
        payload["transaction_receipt"] = formData?.transaction_receipt;
        endpoint = raiseETopUpRequestPaid;
      }
      
      const response = await PostAPI(endpoint, payload);
      if (response.error) {
        setErrorMessage(response?.data?.response?.data?.message);
      } else {
        setResponseData(response?.data?.data);
        setIsTransactionReceipt(true);
        setIsVerificationModelOpen(false);
        setText("");
      }
    } catch (error) {
      console.error(error);
      setErrorMessage("Something went wrong. Please try again.");
    } finally {
      setVerifyLoading(false);
      setPopUpLoading(false);
    }
  };

  const handleClickDone = () => {
    setResponseData({});
    setFormData(initialFormData);
    setIsTransactionReceipt(false);
    setIsPopupOpen(false);
  };
  return (
    <div>
      <AddModel>
        {children}
        <div
          className={`w-1/7 mt-8 ${
            selectedOption === "Paid"
              ? `${notEnglish ? "pl-3" : " pr-3"} border-[#E5E9EB]`
              : ""
          }`}
        >
          <CustomRadioButton
            options={[
              { id: "advance", label: "Advance" },
              { id: "paid", label: "Paid" },
            ]}
            selected={formData?.payment_type}
            onChange={(value) => handleInputChange("payment_type", value)}
            padding={"px-0"}
            dir={notEnglish ? "rtl" : "ltr"}
          />
        </div>
        <div
          className={`w-1/7 ${`${
            notEnglish ? " pl-3" : "pr-3"
          } border-[#E5E9EB]`}`}
        >
          <h1 className={`text-heading3 text-primary_text underline pt-8 pb-4`}>
            {translate("Choose Wallet")}
          </h1>
          <CustomRadioButton
            options={[
              { id: "E Top Up", label: "E Top Up" },
              { id: "Digital Payment", label: "Digital Payment" },
            ]}
            isDisabled={["Digital Payment"]}
            selected={formData?.choose_wallet}
            onChange={(value) => handleInputChange("choose_wallet", value)}
            padding={"px-0"}
            dir={notEnglish ? "rtl" : "ltr"}
          />
        </div>
        <div className="flex flex-col mt-4" dir={notEnglish ? "rtl" : "ltr"}>
          <AddInputs
            mapping={true}
            inputs={inputs}
            totalInputCount={7}
            onInputChange={handleInputChange}
            inputValues={formData}
            errors={errors}
            isDisabledField={id ? ["phone_number"] : []}
            edit={id ? true : false}
            RequiredPostalCode={true}
          />
        </div>
        {(formData.payment_type === "paid" && formData.receiver_payment_source !== "Mobile Money") && (
          <Paid
            formData={formData}
            handleInputChange={handleInputChange}
            notEnglish={notEnglish}
            errors={errors}
          />
        )}
        {(formData.payment_type === "paid" && formData.receiver_payment_source === "Mobile Money") && (
          <PaidMobileMoney
          formData={formData}
          handleInputChange={handleInputChange}
          notEnglish={notEnglish}
          errors={errors}
        />
        )}
        <div dir={notEnglish ? "rtl" : "ltr"}>
          <TextArea
            top={"pt-0"}
            required={false}
            label={"Note"}
            text={text}
            setText={setText}
            textError={textError}
            setTextError={setTextError}
            maxLength={250}
            placeholderRequied={false}
          />
        </div>
      </AddModel>
      <AddBottomButton
        buttonWidth={"w-[140px]"}
        buttonName={`Submit`}
        buttonClass={`w-[140px] whitespace-nowrap cursor-pointer`}
        onClick={handleSubmit}
        disabled={false}
        loading={loading}
      />
      {isPopupOpen && (
        <CustomModal
          isOpen={isPopupOpen}
          onClose={() => setIsPopupOpen(false)}
          title={translate("E Top Up Request")}
          subText={
            isPopupPage === 1
              ? translate(
                  `You are about to initiate a E Top Up request from ${
                    formData?.request_from?.user_code
                  } -  ${formData?.request_from?.first_name ?? ""} ${
                    formData?.request_from?.last_name ?? ""
                  }.`
                )
              : translate(
                  `You are about to initiate a E Top Up request from ${
                    formData?.request_from?.user_code
                  } -  ${formData?.request_from?.first_name ?? ""} ${
                    formData?.request_from?.last_name ?? ""
                  } for AFA ${formData.amount}.`
                )
          }
          onHandleClose={() =>
            isPopupPage === 2 ? setIsOpenPage(1) : setIsPopupOpen(false)
          }
          primaryButtonText={
            isPopupPage === 1 ? translate("Next") : translate("Confirm")
          }
          secondaryButtonText={
            isPopupPage === 1 ? translate("Cancel") : translate("Back")
          }
          handelSubmit={handleSubmitPopup}
          buttonColor={"bg-p_primary"}
          buttonLoading={popUpLoading}
          buttonWidth="w-[108px]"
        />
      )}
      {isVerificationModelOpen && (
        <PinVerificationModel
          handleClose={() => setIsVerificationModelOpen(false)}
          pin={pin}
          setPin={setPin}
          handleDropdownChange={handleInputChange}
          selectedDropDownValue={formData?.pin_interval}
          isDontAskAgainChecked={formData?.isDontAskAgainChecked}
          handleClickVerify={() => handleClickVerify(true)}
          verifyLoading={verifyLoading}
          errorMessage={errorMessage}
          setErrorMessage={setErrorMessage}
          dropdownError={errors?.pin_interval}
        />
      )}
      {isTransactionReceipt && (
        <TransactionReceipt
          details={responseData}
          handleClickDone={handleClickDone}
        />
      )}
    </div>
  );
}
